export const truncFilename = (text: string, maxSize: number): string => {
	if (text.length < maxSize) {
		return text;
	}

	const split = text.split('.');
	const len = split.length;

	return split[0].substring(0, 10) + '...' + (len > 1 ? split[len - 1] : '');
};
